import { render, staticRenderFns } from "./GameList.vue?vue&type=template&id=4eff8242&"
import script from "./GameList.js?vue&type=script&lang=js&"
export * from "./GameList.js?vue&type=script&lang=js&"
import style0 from "./GameList.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports